import React from 'react';
import RecordPrint from '../../components/Record/RecordPrint';

const RecordPrintPage = () => {
    return (
        <div>
            <div className='text-center mt-8 mb-8 text-2xl font-bold'>기록증</div>
            <RecordPrint/>
        </div>
    );
};

export default RecordPrintPage;